import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

import "./SampleShareModal.css";

export default function SampleShareModal({ onConfirm, onCancel, handleShareSubmissionInfo }) {
  return (
    <Modal
      open
      closable
      centered
      footer={null}
      onConfirm={onConfirm}
      onCancel={onCancel}
      width="452px"
      closeIcon={<CloseOutlined className="SampleSubmissionModal__closeIcon" />}
      className="SampleShareAlert"
    >
      <div className="SampleShareTitle">Select external sharing for</div>
      <div className="SampleShareBtn">
        <Button
          type="primary"
          size="large"
          onClick={() => handleShareSubmissionInfo("product")}
        >
          Product
        </Button>

      </div>
    </Modal>
  );
}
